import type { ApiClient } from '../client';
import { DeliveryDetailSchema, type DeliveryDetail } from '../schemas/deliveryDetail';

// Read one «Entrega» by its id. The id rides the path (url-encoded); the client attaches
// the Firebase token via the Authorization header, never the URL. Read by delivery id
// alone — no user id needed (AS-026).
export async function fetchDeliveryDetail(client: ApiClient, id: string): Promise<DeliveryDetail> {
  const data = await client.get<unknown>(
    `/app_service/panel/v1/deliveries/${encodeURIComponent(id)}`,
  );
  return DeliveryDetailSchema.parse(data);
}
